import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.1 });
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = ref.current;
      if (el && el.getBoundingClientRect().top < window.innerHeight * 1.2) setFallback(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView || fallback ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};
